module.exports = __webpack_public_path__ + "img/logo.08fa4891.png";